<template>
    <div class="photo-album">
        <template v-for="(item, index) in source" :key="item.src">
            <PhotoFrame @click="scanPhoto(index)" :src="item.src" :alt="item.alt" :title="item.title" />
        </template>
        <div class="scan-photo" v-if="showScanPhoto">
            <PhotoFrame :src="currentPhoto.src" :alt="currentPhoto.alt" :title="currentPhoto.title" />
            <div class="close" @click="closeScanPhoto">关闭</div>
            <div class="preve" @click="scanPhoto(--currentPhotoNumber)">
                <span>上一个</span>
            </div>
            <div class="next" @click="scanPhoto(++currentPhotoNumber)">
                <span>下一个</span>
            </div>
        </div>
    </div>
</template>
<script lang="ts" setup>
import { defineProps, defineExpose, getCurrentInstance, ref, Ref } from "vue";
import PhotoFrame from "@/components/PhotoFrame.vue";
import type { IPhoto } from "@/types/photo";

const instance = getCurrentInstance()?.proxy;

const props = defineProps({
    data: {
        type: Array,
        required: true,
    },
});

const source = props.data as Array<IPhoto>;
let currentPhotoNumber: Ref<number> = ref(0);
let currentPhoto: Ref<IPhoto> = ref({ src: "", alt: "", title: "" });
let showScanPhoto: Ref<boolean> = ref(false);

function getBounds() {
    const rect = instance?.$el.getBoundingClientRect();
    return {
        width: rect.width,
        height: rect.height,
        top: rect.top,
        left: rect.left,
        right: rect.right,
        bottom: rect.bottom,
    };
}

function closeScanPhoto() {
    showScanPhoto.value = false;
}

function scanPhoto(index: number) {
    index = Math.max(0, Math.min(source.length - 1, index));
    showScanPhoto.value = true;
    currentPhotoNumber.value = index;
    const photo: IPhoto = source[index];
    let photoSize = photo.src.match(/\d+x\d+/)?.[0];
    if (photo) {
        if (window.innerWidth < window.innerHeight) {
            photoSize = "768x1280";
        } else {
            photoSize = "1920x1080";
        }
        currentPhoto.value = Object.assign({}, photo, { src: photo.src.replace(/\d+x\d+/, photoSize) });
    } else {
        closeScanPhoto();
    }
}

defineExpose({ getBounds });
</script>
<style lang="scss">
$f16: 16px;
.photo-album {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    align-items: center;
    .photo {
        width: calc(100% / 3);
        min-height: 60px;
    }
    .scan-photo {
        position: fixed;
        top: 0;
        left: 0;
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.8);
        .photo {
            width: auto;
            max-width: 100%;
            max-height: 100%;
            border-radius: 0;
            background-color: rgba(255, 255, 255, 0.03);
            box-shadow: 0 0 $f16 * 0.5 #eee;
            img {
                max-width: 100%;
                max-height: 100%;
                border-radius: 0;
                box-shadow: none;
            }
            &:hover {
                img {
                    transform: scale(1);
                }
            }
        }
        .close {
            position: absolute;
            top: $f16;
            right: $f16;
            color: white;
            cursor: pointer;
            z-index: 99;
        }
        .preve,
        .next {
            position: fixed;
            top: 0;
            left: 0;
            width: 50%;
            height: 100%;
            // background-color: rgba(255, 255, 255, 0.3);
            // box-shadow: 0 0 $f16 * 0.5 #eee;
            cursor: pointer;
            transition: all 0.5s ease-in-out;
            box-sizing: border-box;
            z-index: 98;
            i {
                font-size: $f16 * 1.125;
            }
            span {
                display: none;
                line-height: $f16 * 3;
                font-size: $f16 * 0.875;
                color: white;
            }
            &:hover {
                // box-shadow: 0 0 $f16 * 1.125 #eee;
            }
        }
        .next {
            left: auto;
            right: 0;
        }
    }
}
@media screen and (max-width: 768px) {
    .photo-album {
        .photo {
            width: 50%;
        }
    }
}
@media screen and (max-width: 480px) {
    .photo-album {
        .photo {
            width: 100%;
        }
    }
}
</style>
